import { useEffect, useState } from 'react';

import { EnumOption } from '../../../modules/types/types';
import httpClient from '../../httpClient';

export const useSubtipoExameMedsus = () => {
  const [subtipoExame, setSubtipoExame] = useState<EnumOption[]>([]);
  const [codigoExame, setCodigoExame] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await httpClient.get(
          `/api/medsusdocumento-subtipoexame`,
        );
        const registros = response.data?.registros ?? [];
        const subtipoOptions = registros.map(
          (registro: { id: number; nome: string }) => ({
            value: registro.id.toString(),
            label: registro.nome,
          }),
        );

        const codigoOptions = registros.map(
          (registro: { id: number; codigo: string }) => ({
            value: registro.id.toString(),
            label: registro.codigo ?? 'Não consta',
          }),
        );

        setSubtipoExame([
          { value: '', label: 'Não informado' },
          ...subtipoOptions,
        ]);
        setCodigoExame([
          { value: '', label: 'Não informado' },
          ...codigoOptions,
        ]);
      } catch (error) {
        console.error('Erro ao buscar Subtipos de Exames MedSUS.', error);
      }
    };

    fetchData();
  }, []);

  return { SubtipoExame: subtipoExame, CodigoExame: codigoExame };
};
